import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Observer, Subject } from 'rxjs/Rx';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import Swal from 'sweetalert2';

import { RicaricaCartaDVM, ServizioDaRicaricareDVM, LeggiCartaCashVM } from "../models/ricarica-carta";
import { Form } from '@angular/forms';
import { PrelevaCreditiEuroBM, CardIdETipo, FinalResponseBM, CreaCartaSet, CreaCartaTempo, CartaStandAlone, VersaCreditiEuroBM, CreaCartaTempoSilicloudBM } from '../models/carta';
import { ConfigurazioneInfoVM } from '../models/configurazione-info';
import { KeyValueVM } from '../models/KeyValueVM';
import { ComandoGenericoBM } from '../models/shared';

declare var require: any;
const swal = require('sweetalert2');

@Injectable()
export class DriverService {

  private pathDriver: string;

  constructor(private http: HttpClient) {

  }

  public setPathDriver(_PathDriver: string): void {
    this.pathDriver = _PathDriver;
    console.log("[DriverService.setPathDriver]: pathDriver", this.pathDriver);
  }

  public getIdCarta(): Observable<string> {
    var options = new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' });
    return this.http.get(this.pathDriver + 'getcardid', { headers: options })
      .catch((error: any) => { return this.handleDriverError("Lettura Card", error, true) })
      .map((response: any) => {
        return response.IdCard;
      });
  }

  public leggiIdCartaETipo(idImpianto: number): Observable<CardIdETipo> {
    return this.http.get(this.pathDriver + 'leggiIdCartaETipo', { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Lettura Id Card e Tipo", error, false) })
      .map((response: any) => {
        return response;
      });
  }

  //RICARICA CARTA
  public getRicaricaCarta(catchErrorCode: boolean, idImpianto: number): Observable<RicaricaCartaDVM> {
    return this.http.get(this.pathDriver + 'getservizicarta', { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Ricarica Carta", error, catchErrorCode) })
      .map((response: any) => {
        return response;
      });
  }

    public postRicaricaCarta(Servizi: ServizioDaRicaricareDVM[], idImpianto: number, idCarta: string): Observable<boolean> {

    var data = { ServiziDaRicaricare: Servizi, idCarta: idCarta };

    return this.http.post(this.pathDriver + 'ricaricacard', data, { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Ricarica Carta", error, true) })
      .map((response: any) => {
        return true;
      });
  }
  //FINE RICARICA CARTA

  //CREA CARTA TEMPO
  public postCreaCartaTempo(carta: CreaCartaTempo): Observable<boolean> {
    return this.http.post(this.pathDriver + 'CreaCartaTempo', carta, { headers: this.getCustomHeadersWithImplantId(carta.idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Crea Carta Tempo", error, true) })
      .map((response: any) => {
        return true;
      });
  }
  //FINE CREA CARTA TEMPO

  //CREA CARTA SET
  public postCreaCartaSET(carta: CreaCartaSet): Observable<boolean> {
    return this.http.post(this.pathDriver + 'CreaCartaSet', carta, { headers: this.getCustomHeadersWithImplantId(carta.idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Crea Carta Set", error, true) })
      .map((response: any) => {
        return true;
      });
  }
  //FINE CREA CARTA SET

  //CREA CARTA STAND ALONE
  public postCreaCartaStandAlone(model: CartaStandAlone): Observable<boolean> {
    return this.http.post(this.pathDriver + 'CreaCartaStandAlone', model, { headers: this.getCustomHeadersWithImplantId(model.idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Crea Carta Stand Alone", error, true) })
      .map((response: any) => {
        return true;
      });
  }
  //FINE CREA CARTA STANDALONE

  //CREA CARTA RICARICA
  public postCreaCartaRicarica(idImpianto: number): Observable<boolean> {
    return this.http.post(this.pathDriver + 'creacartaricarica', null, { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Crea Carta Ricarica", error, true) })
      .map((response: any) => {
        return true;
      });
  }
  public postConvertiCarta(idImpianto: number, tipoCarta: number): Observable<boolean> {
    return this.http.post(this.pathDriver + 'converticard', { tipoCarta: tipoCarta}, { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Converti Carta Ricarica", error, true) })
      .map((response: any) => {
        return true;
      });
  }
  //FINE CREA CARTA RICARICA

  //LEGGI CARTA CREDITI
  public getLeggiCreditiEuro(catchErrorCode: boolean, idImpianto: number): Observable<LeggiCartaCashVM> {
    return this.http.get(this.pathDriver + 'LeggiCreditiEuro', { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Leggi carta crediti", error, catchErrorCode) })
      .map((response: any) => {
        return response;
      });
  }
  //FINE LEGGI CARTA CREDITI

 
  //PRELEVA CREDITI CARTA RICARICA
  public postPrelevaCreditiEuro(Form: PrelevaCreditiEuroBM, idImpianto: number): Observable<FinalResponseBM> {
    return this.http.post(this.pathDriver + "PrelevaCreditiEuro", Form, { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Preleva euro carta", error, true) })
      .map((response: any) => {
        let obj: FinalResponseBM = JSON.parse(response);
        return obj;
      });
  }

  //VERSA EURO SU CARTA RICARICA
  public postVersaCreditiEuro(Form: VersaCreditiEuroBM, idImpianto: number): Observable<FinalResponseBM> {
    return this.http.post(this.pathDriver + "VersaCreditiEuro", Form, { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Versa euro carta", error, true) })
      .map((response: any) => {
        let obj: FinalResponseBM = JSON.parse(response);
        return obj;
      });
  }
  //Leggi ID CARTA E CREDITI CARTA STAND ALONE
  public LeggiCartaStandAlone(idImpianto: number): Observable<CartaStandAlone> {
    return this.http.get(this.pathDriver + "LeggiCartaStandAlone", { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("LeggiCartaStandAlone", error, false) })
      .map((response: any) => {
        return response;
      });
  }

  public postCreaCartaSet(Form: CreaCartaSet, idImpianto: number): Observable<FinalResponseBM> {
    return this.http.post(this.pathDriver + "CreaCartaSet", Form, { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Crea carta Set", error, true) })
      .map((response: any) => {
        let obj: FinalResponseBM = JSON.parse(response);
        return obj;
      });
  }
  
  public postRiallineaCartaCash(idImpianto: number): Observable<boolean> {
    return this.http.post(this.pathDriver + 'RiallineaCartaCash', null, { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Riallinea Carta Cash", error, true) })
      .map((response: any) => {
        return true;
      });
  }
  //FINE /PRELEVA CREDITI CARTA RICARICA

  //LEGGI CONFIG STAMPANTE
  public getConfigInfo(idImpianto: number): Observable<ConfigurazioneInfoVM> {
    var options = new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' });
    return this.http.get(this.pathDriver + 'GetConfigInfo', { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Lettura configurazioni stampante", error, true) })
      .map((response: any) => {
        return response;
      });
  }
  //FINE CONFIG STAMPANTE

  //LEGGI STAMPANTI INSTALLATE
  public getInstalledPrinters(idImpianto: number): Observable<KeyValueVM[]> {
    return this.http.get(this.pathDriver + 'GetInstalledPrinters', { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Lettura stampanti installate", error, true) })
      .map((response: any) => {
        return response;
      });
  }

  public postSetConfigStampante(nomeStampante: string, idImpianto: number): Observable<boolean> {
    var Config = {
      ThermalPrinterName: nomeStampante,
      RfidCom: ''
    };
    return this.http.post(this.pathDriver + "SetPrinter", Config, { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Setta configurazioni alla stampante " + nomeStampante, error, true) })
      .map((response: any) => {
        return response;
      });
  }
  //SET CNFIGURAZINI STAMPANTE

  //INIZIO CONFIGURAZIONI PORTA
  public getSerialPorts(idImpianto: number): Observable<KeyValueVM[]> {
    
    return this.http.get(this.pathDriver + "GetSerialPorts", { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Lettura delle porte", error, true) })
      .map((response: any) => {
        return response;
      });
  }
  public postSetConfigPort(nomePorta: string, idImpianto: number): Observable<boolean> {
    var Config = {
      ThermalPrinterName: '',
      RfidCom: nomePorta
    };
    return this.http.post(this.pathDriver + "SetPort", Config, { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Errore settaggio configurazione porta: " + nomePorta, error, true) })
      .map((response: any) => {
        return response;
      });
  }
  //FINE CONFIGURAZIONI STAMPANTE

  //CAMBIO IMPIANTO CARTA
  public postCambiaImpiantoCarta(idImpiantoProvenienza: number, idImpiantoDestinazione: number): Observable<boolean> {
    var Config = {
      ImpiantoDiProvenienzaId: idImpiantoProvenienza,
      ImpiantoDiDestinazioneId: idImpiantoDestinazione
    };
    return this.http.post(this.pathDriver + "cambiaImpiantoCarta", Config, { headers: this.getCustomHeadersWithImplantId(idImpiantoProvenienza) })
      .catch((error: any) => { return this.handleDriverError("Errore cambio impianto carta", error, true) })
      .map((response: any) => {
        return true;
      });
  }

  public postResettaCarta(idImpianto: number): Observable<boolean> {
    return this.http.post(this.pathDriver + "resettaCarta", idImpianto, { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Errore reset carta", error, true) })
      .map((response: any) => {
        return true;
      });
  }

  public postComandoGenerico(bindingModel: ComandoGenericoBM, idImpianto: number): Observable<boolean> {
    return this.http.post(this.pathDriver + 'ComandoGenerico', bindingModel, { headers: this.getCustomHeadersWithImplantId(idImpianto) })
      .catch((error: any) => { return this.handleDriverError("Comando Generico", error, true) })
      .map((response: any) => {
        return true;
      });
  }

  private handleDriverError(title: string, error: HttpErrorResponse, catchErrorCode: boolean): Observable<any> {
    if (error.status == 408 || error.status == 0) {
      if (!catchErrorCode)
        swal(title, "Errore di comunicazione con il driver", "error");
    }
    else if (error.error.Code == -1) {
      swal(title, "Errore connessione RFid", "error");
    }
    else if (error.error.Code == -2) {
      if (!catchErrorCode)
        swal(title, "Nessuna carta letta", "error");
    }
    else if (error.error.Code == -3) {
      if (!catchErrorCode)
        swal(title, "Errore server remoto", "error");
    }
    else if (error.error.Code == -4)
      swal(title, "Autenticazione card fallita", "error");
    else if (error.error.Code == -5)
      swal(title, "Errore nella scrittura della card", "error");
    else if (error.error.Code == -6)
      console.log("Errore, necessaria la conversione della carta"); //demando al controller di gestire l'errore.
    else if (error.error.Code == -7)
      swal(title, "Card non vuota", "error");
    else if (error.error.Code == -8)
      swal(title, "Tipo di carta non valido", "error");
    else if (error.error.Code == -9) {
      if (error.error.Message != null && error.error.Message.indexOf("Scarica ed installa") > -1)
        swal(title, error.error.Message + "<br><a href='/download/SilicreditRfidDriverServiceInstaller.zip'>scarica</a><br>", "error");
      else
        swal(title, error.error.Message, "error");
    }
    else if (error.error.Code == -10)
      swal(title, error.error.Message, "error"); //errore stampante com
    else if (error.error.Code == -11)
      console.log("Anomalia sulla carta, ritorno l'errore per gestire il riallineamento.");
    else if (error.error.Code == -12)
      swal(title, "Versione del driver obsoleta", "error");
    else if (error.error.Code == -13)
      swal(title, error.error.Message, "error"); //errore porta com
    else if (error.error.Code == -14)
      swal(title, error.error.Message, "error"); //errore lettore com
    else if (error.error.Code == -15)
      swal(title, error.error.Message, "error"); 
    else if (error.error.Code == -16)
      swal(title, error.error.Message, "error");
    else
      swal(title, "Errore imprevisto", "error");

    console.log(title + ": ", error);
    return Observable.throw(error);
  }  

  private getCustomHeadersWithImplantId(idImpianto: number): any {
    return new HttpHeaders({ 'Authorization': 'bearer ' + localStorage.getItem("accessToken"), 'idImpianto': localStorage.getItem("idImpianto") != null ? localStorage.getItem("idImpianto").toString() : idImpianto.toString() });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/driver.service.ts